import { Ref } from "react";

import { FilterCategory, FilterCollection } from "@/api/generatedTypes";
import SelectOption from "@/components/ui-components/SelectOption/SelectOption";
import { multiplyNoun } from "@/helpers/multiplyNoun";

import styles from "./SecondaryCategorySelect.module.scss";

interface SecondaryCategorySelectProps {
  category: FilterCategory | FilterCollection;
  selectCategory(id: string): void;
  selectedCategoryId: string;
  categoryListRef: Ref<HTMLDivElement>;
}

const SecondaryCategorySelect = ({
  category,
  selectCategory,
  selectedCategoryId,
  categoryListRef,
}: SecondaryCategorySelectProps) => {
  return (
    <div className={styles.categories} ref={categoryListRef}>
      <SelectOption
        text={multiplyNoun(String(category?.name))}
        select={() => selectCategory(String(category?.id))}
        selected={category?.id === selectedCategoryId}
      />

      {category?.children?.map((category) => {
        const select = () => {
          selectCategory(category.id);
        };

        return (
          <SelectOption
            text={category.name}
            select={select}
            selected={category.id === selectedCategoryId}
            key={category.id}
          />
        );
      })}
    </div>
  );
};

export default SecondaryCategorySelect;
